const AUDIT_TRAIL_TYPES = {
    CREATE: 1001,
    READ: 1002,
    UPDATE: 1003,
    DELETE: 1004,
    REMOVE: 1005, 
    PARENT_DELETED: 1006
};

export default AUDIT_TRAIL_TYPES;
